module.exports = __webpack_public_path__ + "img/header-weddingRingsWomen@2x.08e371f.jpg";